import api from './api';

export interface StageBucket {
  stage: string;
  count: number;
  value: number;
}

export interface OwnerBucket {
  owner: string;
  count: number;
  value: number;
  won: number;
}

export interface PipelineAnalysis {
  totalDeals: number;
  totalValue: number;
  openValue: number;
  wonValue: number;
  lostValue: number;
  openCount: number;
  wonCount: number;
  lostCount: number;
  winRate: number;
  avgDealSize: number;
  byStage: StageBucket[];
  byOwner: OwnerBucket[];
  insights: string[];
  detectedColumns: { amount?: string; stage?: string; owner?: string; status?: string };
}

class PipelineService {
  async analyze(csv: string): Promise<PipelineAnalysis> {
    const response = await api.post('/pipeline/analyze', { csv });
    return response.data;
  }
}

const pipelineService = new PipelineService();
export default pipelineService;
